import { generateAutomationName } from "../../helpers/generateAutomationName";

export const upgradeButtonKey = generateAutomationName("home", ["header", "upgrade", "button"]);
